"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const selectors_1 = require("@/store/ducks/ports/selectors");
const ports_1 = require("@/store/ducks/ports");
const index_view_1 = __importDefault(require("./index.view"));
function PortsToast() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const portsToastStatus = (0, react_redux_1.useSelector)(selectors_1.portsToastStatusSelector);
    react_1.default.useEffect(() => {
        let close = undefined;
        if (portsToastStatus?.isOpen) {
            close = setInterval(() => {
                dispatch((0, ports_1.closePortsToast)());
            }, 3000);
        }
        return () => clearInterval(close);
    }, [portsToastStatus?.isOpen, portsToastStatus, dispatch]);
    const onClose = react_1.default.useCallback((event, reason) => {
        if (reason === "clickaway") {
            dispatch((0, ports_1.closePortsToast)());
        }
    }, [ports_1.closePortsToast, dispatch]);
    return (react_1.default.createElement(index_view_1.default, { isOpen: Boolean(portsToastStatus?.isOpen), onClose: onClose, severity: portsToastStatus?.status, anchorOrigin: { horizontal: "right", vertical: "top" }, message: portsToastStatus?.message }));
}
exports.default = PortsToast;
